export function accordion() {
  const details = document.querySelectorAll('.c-details');

  details.forEach((elem) => {
    const summary = elem.querySelector('summary');
    const content = elem.querySelector('.c-details__content');

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (elem.open) {
        const closeDetails = content.animate(
          {
            opacity: [1, 0],
            height: [content.offsetHeight + 'px', 0],
          },
          {
            duration: 300,
            easing: 'ease-in',
          }
        );
        closeDetails.onfinish = () => {
          elem.removeAttribute('open');
        };
      } else {
        elem.setAttribute('open', 'true');
        const openDetails = content.animate(
          {
            opacity: [0, 1],
            height: [0, content.offsetHeight + 'px'],
          },
          {
            duration: 300,
            easing: 'ease-in',
          }
        );
      }
    });
  });
}
